<template>
  <div class="paramsInfo-set">
    <div class="sketchMap"></div>
    <div class="paramsInfo-part">
      <CardContainer class="deviceConfigs-part">
        <div class="deviceConfigsSetTitle">{{ $t('Product.deviceConfigsInfo') }}</div>
        <div class="deviceConfigs-list" v-for="(deviceConfig, i) in form.deviceConfigs" :key="i">
          <span class="title">{{ $t('Product.params') }}{{ i + 1 }}:</span>
          <div class="content">
            <div class="content-part">
              <div class="deviceConfigs-select">
                <Select
                  class="select-part"
                  :options="PropertySelectList"
                  v-model="deviceConfig.paramKey"
                  :placeholder="$t('Product.params')"
                  :disabledCode="form.deviceConfigs.map((item) => item.paramKey)"
                  :labelOptions="{
                    key: 'identifier',
                    value: 'name'
                  }"
                  @getRaw="handledeviceConfigsParam(i, arguments)"
                >
                </Select>
                <el-input
                  class="input-part"
                  size="small"
                  :placeholder="$t('Product.paramName')"
                  v-model="deviceConfig.paramName"
                >
                </el-input>
                <SmallUpload
                  style="margin-top: 12px"
                  :width="32"
                  :height="32"
                  :limit="10"
                  :imgStyle="'border-radius:4px'"
                  class="file__uploader"
                  :img="deviceConfig.iconId"
                  accept="image/png,image/jpg,image/jpeg"
                  @pickImg="pickImgdeviceConfigs(i, arguments)"
                >
                </SmallUpload>
                <span class="uploadTips">{{ $t('Product.tips22') }}</span>
              </div>
              <div class="btPart">
                <el-button
                  type="text"
                  :style="form.deviceConfigs.length === 1 || i === 0 ? null : 'color:#A1A5AD'"
                  size="mini"
                  @click="deviceConfigsUp(i)"
                  :disabled="form.deviceConfigs.length === 1 || i === 0"
                >
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-move"></use>
                  </svg>
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  :style="
                    form.deviceConfigs.length === 1 || i === form.deviceConfigs.length - 1
                      ? null
                      : 'color:#A1A5AD'
                  "
                  @click="deviceConfigsDown(i)"
                  :disabled="form.deviceConfigs.length === 1 || i === form.deviceConfigs.length - 1"
                >
                  <svg class="icon" aria-hidden="true" style="transform: rotate(180deg);">
                    <use xlink:href="#icon-move"></use>
                  </svg>
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="deviceConfigsDelete(i)"
                  style="color:#A1A5AD"
                >
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-del_241"></use>
                  </svg>
                </el-button>
              </div>
            </div>
            <div class="deviceConfigs-tempProperty">
              <span class="title">{{ $t('Product.tempProperty') }}:</span>
              <el-radio-group v-model="deviceConfig.isTem">
                <el-radio :label="true">{{ $t('Common.yes') }}</el-radio>
                <el-radio :label="false">{{ $t('Common.no') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div
          class="addBt"
          @click="adddeviceConfigs"
          v-if="
            PropertySelectList &&
              form.deviceConfigs &&
              PropertySelectList.length > 0 &&
              PropertySelectList.length !== form.deviceConfigs.length
          "
        >
          {{ $t('Common.create') }}
        </div>
      </CardContainer>
    </div>
    <div class="bottomBt">
      <hl-button
        type="secondary"
        @click.native="save"
        :loading="saveLoading"
        :style="publishShow ? '' : 'margin-right:24px'"
      >
        {{ $t('Common.save') }}
      </hl-button>
      <hl-button
        @click.native="publish"
        v-show="publishShow"
        style="margin-right:24px"
        :loading="publishLoading"
      >
        {{ $t('Common.publish') }}
      </hl-button>
    </div>
  </div>
</template>

<script>
import Select from '@/components/CommonForm/Select'
import SmallUpload from '../component/SmallUploadButton'
import { uploadFile } from '@/utils/utils'
export default {
  name: 'index',
  props: {
    productKey: {
      type: String,
      default: ''
    }
  },
  components: {
    Select,
    SmallUpload
  },
  data() {
    return {
      form: {
        deviceConfigs: []
      },
      PropertySelectList: [],
      saveLoading: false,
      publishShow: true,
      publishLoading: false
    }
  },
  created() {
    this.getTempInfoList()
  },
  mounted() {
    this.initData()
  },
  methods: {
    uploadFile,
    cancel() {},
    //初始化赋值
    initData() {
      if (this.productKey) {
        const params = {
          productKey: this.productKey
        }
        this.$ajax
          .get(this.$api.product.iceProduct_params_edit_template_detail, params)
          .then((res) => {
            if (res.data) {
              this.form = {
                deviceConfigs: res.data.deviceConfigs || []
              }
              this.publishShow = res.data.update
            } else {
              this.form = {
                deviceConfigs: []
              }
            }
          })
      } else {
        this.form = {
          deviceConfigs: []
        }
      }
    },
    checkForm(arr) {
      let pass = true
      pass = arr.every((x1) => {
        return x1.paramKey && x1.paramName && x1.paramKey.length > 0 && x1.paramName.length > 0
      })
      if (!pass) {
        this.$message.warning('信息未完善,请完整填写参数与参数名称')
      }

      return pass
    },
    save() {
      // iceProduct_params_template_save
      if (!this.checkForm(this.form.deviceConfigs)) return
      this.saveLoading = true
      let params = {
        productKey: this.productKey,
        deviceConfigs: this.form.deviceConfigs
      }
      let api = this.$api.product.iceProduct_params_edit_template_save
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.saveSuccess')}`)
            this.publishShow = true
          }

          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.saveLoading = false
        })
    },
    publish() {
      this.publishLoading = true
      let params = {
        productKey: this.productKey
      }
      let api = this.$api.product.iceProduct_params_edit_template_publish
      this.$ajax
        .get(api, params)
        .then((res) => {
          if (res.success) {
            this.$message.success(`${this.$t('Common.operationSuccess')}`)
            this.publishShow = false
          }

          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.publishLoading = false
        })
    },
    //获取状态列表下拉框
    getFuncStateList() {
      const params = {
        productKey: this.productKey
      }
      this.$ajax.get(this.$api.product.product_template_func_state_select, params).then((res) => {
        this.stateListOptions = res.data
      })
    },

    //温度区图片上传
    async pickImgdeviceConfigs(i, argu) {
      console.log(argu[0], i)
      let file = argu[0]
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.form.deviceConfigs[i]['iconId'] = res.data
          })
          .catch(() => {})
      } else {
        this.form.deviceConfigs[i]['iconId'] = ''
      }
    },
    //温度信息上移
    deviceConfigsUp(i) {
      let arr = JSON.parse(JSON.stringify(this.form.deviceConfigs))
      arr.splice(i - 1, 1, ...arr.splice(i, 1, arr[i - 1]))
      this.form.deviceConfigs = arr
    },
    //温度信息下移
    deviceConfigsDown(i) {
      let arr = JSON.parse(JSON.stringify(this.form.deviceConfigs))
      arr.splice(i, 1, ...arr.splice(i + 1, 1, arr[i]))
      this.form.deviceConfigs = arr
    },
    //温度信息删除
    deviceConfigsDelete(i) {
      this.form.deviceConfigs.splice(i, 1)
    },
    //新增温度信息
    adddeviceConfigs() {
      this.form.deviceConfigs.push({
        isTem: true
      })
    },

    handledeviceConfigsParam(i, list) {
      console.log(i, list[0])
      this.$set(this.form.deviceConfigs[i], 'paramName', list[0]['name'])
    },

    //获取状态列表下拉框
    getTempInfoList() {
      const params = {
        productKey: this.productKey,
        draft: false
      }
      this.$ajax.get(this.$api.product.product_tsl_property_list, params).then((res) => {
        this.PropertySelectList = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.paramsInfo-set {
  display: flex;
  .sketchMap {
    width: 330px;
    height: 720px;
    //border: 1px solid #333333;
    background-image: url('../../../../../assets/product_model_pic_parameter_editor.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .paramsInfo-part {
    margin-left: 24px;
    flex: 1;
    .deviceConfigs-part {
      margin-bottom: 24px;
      .deviceConfigsSetTitle {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
      }
      .deviceConfigs-list {
        display: flex;
        align-items: center;
        margin-top: 16px;
        .title {
          color: #303133;
        }
        .content {
          flex: 1;
          border: 1px dashed #e4e7ed;
          border-radius: 8px;
          padding: 0 16px;
          align-items: center;
          line-height: 32px;
          .content-part {
            margin-left: 16px;
            display: flex;

            justify-content: space-between;
            //height: 64px;
            .deviceConfigs-select {
              display: flex;
              .select-part {
                margin-right: 8px;
                padding-top: 12px;
              }
              .input-part {
                width: 150px;
                margin-right: 8px;
                padding-top: 12px;
              }
              .uploadTips {
                padding-top: 12px;
                margin-left: -240px;
                font-size: 12px;
                color: #909399;
              }
            }

            .btPart {
              display: flex;
            }
          }
          .deviceConfigs-tempProperty {
            margin-left: 16px;
            .title {
              display: inline-block;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}
.addBt {
  margin-top: 24px;
  height: 32px;
  background: #f0f2fc;
  border-radius: 4px;
  border: 1px solid #8fa2e3;
  text-align: center;
  line-height: 32px;
  color: #2046c7;
  cursor: pointer;
  &:hover {
    background: #f0f2fc;
    border: 1px solid #bcc7ee;
  }
  &:active {
    background: #bcc7ee;
    border: 1px solid #637dd7;
  }
}
.bottomBt {
  background-color: #ffffff;
  left: -24px;
  right: -24px;
  position: fixed;
  bottom: 0;
  z-index: 4;
  height: 50px;
  width: calc(100vw + 240px);
  border-radius: 16px;
  text-align: right;
  padding-right: 214px;
  padding-top: 10px;
  box-shadow: 5px 0 25px 8px rgba(215, 222, 230, 0.4);
}
</style>
